import { atom, selector } from "recoil"
import { GRID_PAGE_NAME, Routes } from "../../../constants"
import {
  AvatarConfig,
  AvatarDetail,
  AvatarGesture,
  AvatarsErrorMessageType,
  AvatarVideoSize
} from "./types"

export const avatarsErrorMessageAtom = atom<AvatarsErrorMessageType>({
  key: "avatarsErrorMessageAtom",
  default: null
})

export const avatarsAtom = atom<AvatarDetail | null>({
  key: "avatarsAtom",
  default: null
})

export const avatarsSelector = selector({
  key: "avatarsSelector",
  get: ({ get }) => get(avatarsAtom),

  set: ({ set }, value) => set(avatarsAtom, value)
})

export const avatarsLoading = atom<boolean>({
  key: "avatarsLoading",
  default: true
})

export const gridSelectedAvatarAtom = atom<AvatarConfig | null>({
  key: "gridSelectedAvatarAtom",
  default: null
})

export enum AvatarDimensionality {
  twoDimensional,
  threeDimensional,
}

export const gridSelectedAvatarDimensionalityAtom = atom<AvatarDimensionality | null>({
  key: "gridSelectedAvatarDimensionalityAtom",
  default: null
})

export const navigatedFromAvatarsListAtom = atom<boolean>({
  key: "navigatedFromAvatarsListAtom",
  default: GRID_PAGE_NAME === Routes.AVATARS.replace("/", "")
})

export const gridHeaderSearchTextAtom = atom({
  key: "gridHeaderSearchTextAtom",
  default: ""
})
